<template>
    <VLayout class="rounded-md flex-column">
        <VMain>
            <div class="layout-box">
                <slot></slot>
            </div>
        </VMain>

        <VFooter class="surface-card border-top-1 surface-border"
                 app>
            <div class="w-full text-center py-2 text-sm text-color-secondary">
                {{ new Date().getFullYear() }} &copy; {{ __('All rights reserved') }}
            </div>
            <div class="session-time-header"></div>
        </VFooter>
    </VLayout>
</template>

<script setup>
import { onBeforeMount, nextTick } from "vue";
import { initFunctions } from "../../init.js";
import { __ } from '@helper/utils.js'

onBeforeMount(async () => {
    await nextTick()
    initFunctions();
})
</script>

<style scoped></style>
